'use strict';
const Login = require('./login/home/index.jsx');
const LoginForgot = require('./login/forgot/index.jsx');
const LoginReset = require('./login/reset/index.jsx');
const NotFound = require('./not-found.jsx');
const React = require('react');
const ReactRouter = require('react-router-dom');
const RouteRedirect = require('../../components/route-redirect.jsx');

import { ToastContainer, toast } from 'react-toastify';

const Route = ReactRouter.Route;
const Switch = ReactRouter.Switch;


class AppUniversal extends React.Component {

    componentDidMount() {
        window.notify = (type, message) => {
            try {
                toast[type](message, { closeButton: false });
            } catch (e) {
            }
        };
    }

    render() {
        return (
            <div class="top-level-app">
                <Switch>
                    <Route path="/" exact component={ Login }/>
                    <Route path="/login" exact component={ Login }/>
                    <Route path="/login/forgot" exact component={ LoginForgot }/>
                    <Route path="/login/reset/:phone/:username/:key" component={ LoginReset }/>
                    <Route path="/login/logout" exact component={ Login }/>

                    <RouteRedirect from="/moved" to="/" code={ 301 }/>

                    <Route component={ NotFound }/>
                </Switch>

                <ToastContainer/>
            </div>
        );
    };
}

module.exports = AppUniversal;



// WEBPACK FOOTER //
// ./client/pages/main/app-universal.jsx